import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { UserIface } from '../../../../interfaces/user.iface';
import { CommentIface } from '../../../../interfaces/comment.iface';
import { OffersService } from '../../../../services/offers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-comment-select-dialog',
  templateUrl: './comment-select-dialog.component.html',
  styleUrls: ['./comment-select-dialog.component.scss']
})
export class CommentSelectDialogComponent implements OnInit {
  public commentAddForm: FormGroup;
  public comment: CommentIface;
  public user: UserIface;
  public edit: boolean;

  constructor(
    public dialogRef: MatDialogRef<CommentSelectDialogComponent>,
    private authService: AuthService,
    private offersService: OffersService,
    public translate: TranslateService
  ) {
    this.commentAddForm = new FormGroup({
      content: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    this.edit = false;
    this.offersService.comment$.subscribe(comment => {
      if (comment) {
        this.commentAddForm.setValue({ content: comment.content });
        this.comment = comment;
        this.edit = true;
      }
    });
  }

  save(): void {
    if (!this.edit) {
      this.comment = {
        content: this.commentAddForm.get('content').value,
        author: this.authService.user.username,
        date: Date.now(),
        isNew: true
      };
    } else {
      this.comment.content = this.commentAddForm.get('content').value;
    }
    this.dialogRef.close({ comment: this.comment, edit: this.edit });
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-edit/comment-select-dialog/comment-select-dialog.component.ts